import { render, staticRenderFns } from "./Service-3.vue?vue&type=template&id=2bee5015&scoped=true&"
import script from "./Service-3.vue?vue&type=script&lang=js&"
export * from "./Service-3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bee5015",
  null
  
)

export default component.exports